"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _TrialActivationSuccessSurveyModal = _interopRequireDefault(require("./TrialActivationSuccessSurveyModal"));

var _activateTrial = require("ui-addon-upgrades/_core/trial/activateTrial");

var _ActivationErrorModal = _interopRequireDefault(require("./ActivationErrorModal"));

var _ActivationSuccessModal = _interopRequireDefault(require("./ActivationSuccessModal"));

var _sources = require("../data/upgradeData/properties/sources");

var _trials = require("../constants/trials");

var STATUSES = {
  LOADING: 'loading',
  ERROR: 'error',
  SUCCESS: 'success'
};

var TrialActivationModalContainer =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(TrialActivationModalContainer, _Component);

  function TrialActivationModalContainer(props) {
    var _this;

    (0, _classCallCheck2.default)(this, TrialActivationModalContainer);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(TrialActivationModalContainer).call(this, props));
    _this.state = {
      trialActivationRequestStatus: STATUSES.LOADING
    };
    return _this;
  }

  (0, _createClass2.default)(TrialActivationModalContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this._isMounted = true;
      var upgradeData = this.props.upgradeData;
      (0, _activateTrial.activateTrial)(upgradeData).then(function () {
        if (_this2._isMounted) {
          _this2.setState({
            trialActivationRequestStatus: STATUSES.SUCCESS
          });
        }
      }).catch(function () {
        if (_this2._isMounted) {
          _this2.setState({
            trialActivationRequestStatus: STATUSES.ERROR
          });
        }
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._isMounted = false;
    }
  }, {
    key: "render",
    value: function render() {
      var trialActivationRequestStatus = this.state.trialActivationRequestStatus;
      var _this$props = this.props,
          upgradeData = _this$props.upgradeData,
          upgradeProduct = _this$props.upgradeData.upgradeProduct,
          shouldHideSurvey = _this$props.shouldHideSurvey,
          onSuccess = _this$props.onSuccess,
          successModalHeader = _this$props.successModalHeader,
          successModalSubText = _this$props.successModalSubText;
      var shouldShowSurvey = _trials.SURVEY_UPGRADE_PRODUCTS.includes(upgradeProduct) && !shouldHideSurvey;

      switch (trialActivationRequestStatus) {
        case STATUSES.LOADING:
          return null;

        case STATUSES.ERROR:
          return _react.default.createElement(_ActivationErrorModal.default, null);

        case STATUSES.SUCCESS:
          if (shouldShowSurvey) {
            return _react.default.createElement(_TrialActivationSuccessSurveyModal.default, {
              onSuccess: onSuccess,
              upgradeData: upgradeData
            });
          }

          return _react.default.createElement(_ActivationSuccessModal.default, {
            type: _sources.sourceKeys.TRIAL,
            onSuccess: onSuccess,
            header: successModalHeader,
            subText: successModalSubText
          });

        default:
          return null;
      }
    }
  }]);
  return TrialActivationModalContainer;
}(_react.Component);

TrialActivationModalContainer.propTypes = {
  upgradeData: _react.PropTypes.object,
  onSuccess: _react.PropTypes.func,
  shouldHideSurvey: _react.PropTypes.bool,
  successModalHeader: _react.PropTypes.node,
  successModalSubText: _react.PropTypes.node
};
var _default = TrialActivationModalContainer;
exports.default = _default;
module.exports = exports.default;